import { render } from "./Send.vue?vue&type=template&id=39357b68&scoped=true"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"

import "./Send.vue?vue&type=style&index=0&id=39357b68&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-39357b68"

export default script